module.exports = __webpack_public_path__ + "static/media/college_6.4cac2fdf.jpg";